import { render, staticRenderFns } from "./addStaffVariation.vue?vue&type=template&id=404b5760&"
import script from "./addStaffVariation.vue?vue&type=script&lang=js&"
export * from "./addStaffVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports